import parse from 'html-react-parser'

// Tags that cannot legally live inside a <p>. If an answer contains any of
// them the browser auto-closes the <p>, which shows up as a hydration
// mismatch in Next.js - so those answers keep a <div> wrapper.
const BLOCK_LEVEL_TAG =
  /<\s*(address|blockquote|div|dl|fieldset|figure|form|h[1-6]|hr|ol|p|pre|section|table|ul)[\s/>]/i

type FaqAnswerProps = {
  answer?: string | null
  className?: string
}

// Renders an FAQ answer as a paragraph whenever the content allows it, so the
// answer is a real <p> in the DOM for SEO.
const FaqAnswer = ({ answer, className }: FaqAnswerProps) => {
  if (!answer) return null

  if (BLOCK_LEVEL_TAG.test(answer)) {
    return <div className={className}>{parse(answer)}</div>
  }

  return <p className={className}>{parse(answer)}</p>
}

export default FaqAnswer
